// Catalog amounts are stored in CHF Rappen; display converts to the active language's currency.
const SEP = { CHF: "\u2019", EUR: ".", USD: ",", ALL: "." };
let active = { code: "CHF", rate: 1 };
export const setActiveCurrency = (code, rate) => { active = { code, rate: rate || 1 }; };
export const activeCurrency = () => active;

export const money = (minor, code = "CHF", rate = 1) => {
  if (minor == null) return "";
  const v = (Math.round(minor * rate) / 100).toFixed(2);
  const [i, d] = v.split(".");
  const dec = code === "EUR" || code === "ALL" ? "," : ".";
  return `${code} ${i.replace(/\B(?=(\d{3})+(?!\d))/g, SEP[code] || "'")}${dec}${d}`;
};
export const chf = (rappen) => money(rappen, active.code, active.rate);
export const chfBase = (rappen) => money(rappen, "CHF", 1);
export const toBase = (displayValue) => (displayValue === "" || displayValue == null ? displayValue : String(Math.round(Number(displayValue) / active.rate)));
export const toDisplay = (chfValue) => Math.round(chfValue * active.rate);

export const fmtDate = (iso, lang) => (iso ? new Date(iso).toLocaleDateString(`${lang}-CH`, { day: "2-digit", month: "2-digit", year: "numeric" }) : "");
export const addDays = (n, lang) => {
  const d = new Date();
  let added = 0;
  while (added < n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) added += 1; }
  return d.toLocaleDateString(`${lang}-CH`, { weekday: "short", day: "2-digit", month: "2-digit" });
};
